import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  Select,
  MenuItem,
  Divider,
  Button,
  Avatar,
  Link,
  IconButton,
} from "@mui/material";
import { FaCcVisa, FaCcMastercard } from "react-icons/fa";
import { SiTether } from "react-icons/si";
import { TbCurrencyEthereum } from "react-icons/tb";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FaTiktok } from "react-icons/fa6";
import { FaTelegram } from "react-icons/fa";

import { FaInstagram } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";
import { useLangCountry } from "../../utils/getLangCountry";
import axios from "axios";

const languages = [
  {
    code: "en",
    label: "English",
    flag: "/Images/card3south.png",
  },
  // {
  //   code: "ar",
  //   label: "Arabic",
  //   flag: "/Images/Arbics.png", // Replace with actual path
  // },
  {
    code: "fr",
    label: "French",
    flag: "/Images/france.png", // Replace with actual path
  },
];



const Footer = () => {
  const { lang } = useLangCountry();
  const navigate = useNavigate();
  const { language, toggleLanguage, translations } = useLanguage();
  const [flagUrl, setFlagUrl] = useState(""); // fallback
console.log("asdfgadGFAd",flagUrl);

  const handleChange = (event) => {
    const newLang = event.target.value;
    localStorage.setItem("selectedLanguage", newLang);
    toggleLanguage(newLang);
  };


  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get("https://ipwhois.app/json/");
        const ipCountryCode = response.data.country; // e.g., 'IN'

        console.log("sdfsdfsdfsa", ipCountryCode);

        setFlagUrl(ipCountryCode);
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCountryCode();
  }, []);



  const OfferingOffering = [
    { label:  translations[language]?.AllReff, route: "#" },
    // { label: translations[language]?.whoIsBBCorp, route: "#" },
    { label: "Partner with us", route: "/partner" },

  ];

  const footerLinks = [
    { label: translations[language]?.footerHelp, path: "/help" },
    { label: translations[language]?.footerContact, path: "/contact" },
    { label: translations[language]?.footerPolicy, path: "/Images/TERMSCON.pdf", isPdf: true, },
    { label: translations[language]?.footerTerm, path: "/Images/TERMSCON.pdf", isPdf: true, },
  ];
  const footerComapny = [
    // { label: translations[language]?.whoIsBBCorp, path: "" },
    { label: "Who is BBcorp?", path: "/why" },
    { label: translations[language]?.careers, path: "/careers" },
    // { label: translations[language]?.legalDocuments, path: "/legal" },
    { label: translations[language]?.bbcropAwards, path: "" },
  ];

  const footerComapnyOfder = [
    // { label: translations[language]?.whoIsBBCorp, path: "" },
    { label: translations[language]?.AllReff, path: "#" },
    { label: translations[language]?.partnerWithUs, path: "/partner" },
    // { label: translations[language]?.legalDocuments, path: "/legal" },
  ];

  const categories = [
    {
      name: translations[language]?.footerForex,
      nav: "/forex-trading",
    },
    {
      name: translations[language]?.footerStock,
      nav: "/stock-derivatives",
    },
    {
      name: translations[language]?.footerCommaondities,
      nav: "/commodities",
    },
    {
      name: translations[language]?.footerPrecious,
      nav: "/precious-metals",
    },
    {
      name: translations[language]?.footerShares,
      nav: "/shares",
    },
    {
      name: translations[language]?.footerCrypto,
      nav: "/cryptocurrencies",
    },
    {
      name: translations[language]?.footerEquity,
      nav: "/equity",
    },
    {
      name: translations[language]?.footerEnergies,
      nav: "/energies",
    },
  ];



  const handleClick = (item) => {
    const userCountry = localStorage.getItem('userCountry');
    const currentPath = window.location.pathname;
    
    // Check if we're currently in a country-specific path
    const isInCountryPath = currentPath.includes(`/${lang}/lb`);
    
    if (item.startsWith("/")) {
      if (userCountry === "lb" || isInCountryPath) {
        navigate(`/${lang}/lb${item}`);
      } else {
        navigate(`/${lang}${item}`);
      }
    } else {
      navigate(item);
    }
    // window.location.reload();
  };
  return (
    <Box
      sx={{
        background:
          "linear-gradient(to bottom, #F2F9FC 0%, #F2F9FC 20%, #FFFFFF 100%)",
        pt: 6,
        pb: 2,
        marginTop: { xs: "1rem", md: "8rem " },
        overflow: "hidden",
      }}
    >
      <Box sx={{ padding: { xs: " 35px", md: "10px 5.5rem" } }}>
        <Grid container spacing={{ xs: 4, sm: 10, md: 12 }}>
          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
            sx={{ order: { xs: 1, sm: "initial" } }}
          >
            <Typography variant="subTitle3" mb={1}>
              {translations[language]?.footerAccounts}
            </Typography>
            {[translations[language]?.footerAccount]?.map((item) => (
              <Typography
                variant="h5"
                color="#667085"
                mb={2}
                mt={2}
                key={item}
                sx={{ cursor: "pointer", ml: { xs: "-17px", sm: "0px" } }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/account");
                  // window.location.reload();
                }}
              >
                {item}
              </Typography>
            ))}
          </Grid>
          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
            sx={{ order: { xs: 5, sm: "initial" } }}
          >
            <Typography variant="subTitle3" mb={1}>
              {translations[language]?.footerMarket}
            </Typography>
            {categories?.map((item) => (
              <Typography
                variant="h5"
                color="#667085"
                mb={2}
                mt={2}
                key={item}
                sx={{ cursor: "pointer", ml: { xs: "-17px", sm: "0px" },                    "&:hover": { color: "#19ABE2", textDecoration: "none" },
 }}
                onClick={() => handleClick(item?.nav)}
              >
                {item?.name}
              </Typography>
            ))}
          </Grid>
          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
            sx={{ order: { xs: 3, sm: "initial" } }}
          >
            <Typography variant="subTitle3" mb={1}>
              {translations[language]?.footerOffering}
            </Typography>
            {/* {[
              // translations[language].footerCompetitions,
              // translations[language].footerPolicy,
              // translations[language]?.footerLeverage,
              translations[language]?.AllReff,
              translations[language]?.partnerWithUs,
            ].map((item) => (
            // {footerComapnyOfder.map((item) => ( */}

            {footerComapnyOfder?.map((item) => (

              <Typography
                variant="h5"
                key={item.label}
                color="#667085"
                mb={2}
                mt={2}
                // key={item}
                onClick={() => navigate(item.path)}

                sx={{
                  cursor: "pointer", ml: { xs: "-17px", sm: "0px" }, "&:hover": { color: "#19ABE2", textDecoration: "none" },
                }}
              >
                {item?.label}
              </Typography>
            ))}
          </Grid>
          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
            sx={{
              order: { xs: 2, sm: "initial" },
              ml: { xs: "25px", md: "0px" },
            }}
          >
            <Typography variant="subTitle3" mb={1}>
              {translations[language]?.footerPlatform}
            </Typography>
            {[
              translations[language]?.mt5Platforms,
              // translations[language]?.partnerWithUs,
            ]?.map((item) => (
              <Typography
                variant="h5"
                color="#667085"
                mb={2}
                mt={2}
                key={item}
                sx={{
                  cursor: "pointer", ml: { xs: "-17px", sm: "0px" }, "&:hover": { color: "#19ABE2", textDecoration: "none" },
                }}
                onClick={() => handleClick("/mt5")}
              >
                {item}
              </Typography>
            ))}
          </Grid>

          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
            sx={{ order: { xs: 4, sm: "initial" } }}
          >
            <Typography variant="subTitle3" mb={1}>
              {translations[language]?.companyInfo}
            </Typography>
            <>
              {footerComapny.map((item) => (
                <Typography
                  key={item.label}
                  variant="h5"
                  color="#667085"
                  mb={2}
                  mt={2}
                  sx={{
                    cursor: "pointer",
                    ml: { xs: "-17px", sm: "0px" },
                    "&:hover": { color: "#19ABE2", textDecoration: "none" },

                    // "&:hover": { color: "#19ABE2", textDecoration: "underline" },
                  }}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </Typography>
              ))}
            </>
          </Grid>
          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
            sx={{ order: { xs: 4, sm: "initial" } }}
          >
            <Typography variant="subTitle3" mb={1}>
              {translations[language]?.FoterSupport}
            </Typography>
            <>
              {footerLinks.map((item) => (
                <Typography
                  key={item.label}
                  variant="h5"
                  color="#667085"
                  mb={2}
                  mt={2}
                  sx={{
                    cursor: "pointer",
                    ml: { xs: "-17px", sm: "0px" },
                    "&:hover": { color: "#19ABE2", textDecoration: "none" },
                  }}
                  onClick={() => {
                    if (item.isPdf) {
                      window.open(item.path, "_blank");
                    } else {
                      navigate(item.path);
                    }
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </>
          </Grid>
        </Grid>
        {/* <Box
          sx={{
            width: "fit-content", // 👈 so it doesn't stretch full width
            ml: "auto", // 👈 this pushes the box to the right
          }}
        >
          <Typography
            fontWeight={500}
            color="#1A1C1E"
            fontSize={16}
            mt={0}
            mb={1}
            sx={{ padding: { xs: 2, md: 0 } }}
          >
            {translations[language]?.footerPayment}
          </Typography>
          <Box
            display="flex"
            gap={1}
            alignItems="center"
            sx={{ padding: { xs: 2, md: 0 } }}
          >
            <img
              src="/Images/visa.png"
              alt="visa"
              style={{ width: "50px", height: "20px", objectFit: "contain" }}
            />
            <img
              src="/Images/circle.png"
              alt="visa"
              style={{ width: "50px", height: "25px", objectFit: "contain" }}
            />
            <img
              src="/Images/tron.png"
              alt="visa"
              style={{ width: "35px", height: "30px", objectFit: "contain" }}
            />
          </Box>
        </Box> */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={4}
          flexWrap="wrap"
          borderBottom="1px solid gray"
          sx={{ padding: { xs: 0, md: 0 } }}
        >
          <Box mt={6} mb={2}>
            <img
              src="/Images/hdddLoho.png"
              alt="Logo"
              style={{ width: "67px", height: "67px" }}
            />
          </Box>
          <Box
            display="flex"
            gap={4}
            sx={{
              padding: { xs: 2, md: 0 },
              marginLeft: { xs: "0px", md: "142px" },
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Button
              component="a"
              href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
              disableRipple
              sx={{
                background: "#fff",
                // border: "1px solid gray",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: 1,
                px: 2,
                py: 1,
              }}
            >
              <img
                src="/Images/transPlay.png"
                alt="Google Play"
                style={{ width: "22px", height: "22px" }}
              />
              <Box sx={{ textAlign: "left" }}>
                <Typography
                  sx={{
                    color: "rgb(62, 68, 71)",
                    fontSize: 10,
                    fontWeight: 500,
                  }}
                >
                  {translations[language]?.footerButton2title}
                </Typography>
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: 14,
                    fontWeight: 600,
                  }}
                >
                  {translations[language]?.footerButtonName}
                </Typography>
              </Box>
            </Button>

            <Button
              component="a"
              href="https://apps.apple.com/us/app/metatrader-5/id413251709"
              target="_blank"
              rel="noopener noreferrer"
              disableRipple
              sx={{
                background: "#FFF",
                // border: "1px solid gray",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: 1,
                px: 2,
                py: 1,
              }}
            >
              <img
                src="/Images/apple.png"
                alt="App Store"
                style={{ width: "35px", height: "35px" }}
              />
              <Box sx={{ textAlign: "left" }}>
                <Typography
                  sx={{
                    color: "rgb(62, 68, 71)",
                    fontSize: 10,
                    fontWeight: 500,
                  }}
                >
                  {translations[language]?.footerButton2title}
                </Typography>
                <Typography
                  sx={{ color: "#000", fontSize: 14, fontWeight: 600 }}
                >
                  {translations[language]?.footerButton2Name}
                </Typography>
              </Box>
            </Button>

            {/* <Select
              value={lang}
              onChange={handleChange}
              size="small"
              IconComponent={ExpandMoreIcon}
              sx={{
                bgcolor: "#F7F7F7",
                borderRadius: "12px",
                border: "1px solid #E0E0E0",
                minWidth: 135,
                px: 1,
                color: "#fff", // selected value text color
                // ✅ Border Styling
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none", // default black border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none", // black on hover
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none", // black on focus
                },
                "& .MuiSelect-icon": {
                  color: "#8D969A", // dropdown icon color
                },
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: "#F7F7F7", // 🔹 White dropdown
                    mt: 1,
                    borderRadius: 2,
                    color: "#667085", // 🔹 Black text in dropdown
                  },
                },
              }}
            >
              {languages.map((langOption) => {
                const isSelected = lang === langOption.code;
                return (
                  <MenuItem
                    key={langOption.code}
                    value={langOption.code}
                    sx={{
                      bgcolor: "#F7F7F7",
                      borderRadius: "6px",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        bgcolor: "transparent",
                        color: "#fff",
                        boxShadow: "0 4px 12px #F7F7F7",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar
                        src={langOption.flag}
                        alt={langOption.label}
                        sx={{ width: 25, height: 25 }}
                      />
                      <Typography variant="body2" sx={{ color: "#667085" }}>
                        {langOption.label}
                      </Typography>
                    </Box>
                  </MenuItem>
                );
              })}
            </Select> */}
          </Box>
        </Box>
        <Box mt={2}>
          {/* <Typography
            sx={{
              fontSize: "22px",
              fontWeight: "500",
              fontFamily: "SF Pro Display",
              color: "#000",
              fontSize: "16px",
              padding: { xs: 0, md: 0 },
            }}
          >
            {translations[language]?.footerLegal}
          </Typography> */}

          <Typography
            variant="h6"
            color="#667085"
            lineHeight={1.6}
            mt={2}
            sx={{ padding: { xs: 0, md: 0 } }}
          >
          {flagUrl ==="Lebanon" ? translations[language]?.footerNews : translations[language]?.footerDescription}  
          </Typography>
        </Box>
        <Box sx={{ borderBottom: "1px solid gray", marginTop: "2rem" }} />

        {/* Footer Bottom Row */}
        <Box
          mt={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
          sx={{ padding: { xs: 0, md: 0 } }}
        >
          {/* Copyright Text */}
          <Typography
            variant="h6"
            sx={{
              color: "#667085",
              fontSize: "14px",
              fontWeight: 500,
              pt: "10px",
            }}
          >
            {translations[language]?.footerCopy} © {new Date().getFullYear()}{" "}
            {translations[language]?.footerRight}
          </Typography>

          {/* Social Icons */}
          <Box display="flex" gap={1}>
            <IconButton
              component="a"
              href="https://api.whatsapp.com/send?phone=96178709578"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#25D366", // LinkedIn blue
                  transform: "scale(1.2)",
                },
              }}
              aria-label="whatsapp"
            >
              <FaWhatsapp />
            </IconButton>

            <IconButton
              component="a"
              href="https://www.instagram.com/bbcorpfx/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#E1306C", // Instagram pink
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Instagram"
            >
              <FaInstagram />
            </IconButton>
            <IconButton
              component="a"
              href="https://tiktok.com/@bbcorpfx"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#010101", // Instagram pink
                  transform: "scale(1.2)",
                },
              }}
              aria-label="tiktok"
            >
              <FaTiktok />
            </IconButton>
            <IconButton
              component="a"
              href="https://t.me/bbcorpltd"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#0088CC", // Twitter/X black
                  transform: "scale(1.2)",
                },
              }}
              aria-label="telegram"
            >
              <FaTelegram />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.facebook.com/people/BBCorp/100094393060215/?mibextid=wwXIfr&rdid=fkECT0btkzJdCpYx&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BedSuHhZf%2F%3Fmibextid%3DwwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#1877F2", // Facebook blue
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Facebook"
            >
              <FiFacebook />
            </IconButton>

            <IconButton
              component="a"
              href="https://x.com/BBcorpSAL"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#000", // Twitter/X black
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Twitter"
            >
              <FaXTwitter />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
